import { Button } from '@avanta/shared/components/ui/Button';
import { Textarea } from '@avanta/shared/components/ui/Textarea';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type OptionDTO } from 'types/surveys';

export const TextArea = ({
  options,
  onSaveResponse,
}: {
  options: OptionDTO[];
  onSaveResponse: (option: OptionDTO, text: string) => void;
}): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.HOME);
  const [text, setText] = useState('');

  const handleOnSaveResponse = (): void => {
    onSaveResponse(options[0], text);
  };

  return (
    <div className="flex flex-col items-end am-lg:gap-10 gap-8 am-lg:mt-6 mt-4">
      <div className="w-full flex flex-col relative self-start">
        <div className="flex flex-col gap-3 max-w-196">
          <Textarea
            placeholder={t('NPSSurvey.Step3.placeholder')}
            className="h-32"
            value={text}
            onChange={e => setText(e.target.value)}
          />
        </div>
      </div>
      <Button
        variant="primary"
        size="lg"
        icon="trailing"
        className="am-lg:w-fit"
        onClick={handleOnSaveResponse}
      >
        {t('NPSSurvey.Step3.cta')}
        <ChevronRight className="size-6" />
      </Button>
    </div>
  );
};
